import client from './client';

const usersClient = {
  async me() {
    const user = await client.get('/users/me/');
    return { user };
  },
};
export default usersClient;
